import React from 'react';
import PropTypes from 'prop-types';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import {Aux} from "../../constants";
import ReceiptCard from './ReceiptCard';

// A picker of unassigned truck receipts (latest first) shown at the point of manual volume entry.
// Selecting a receipt autofills the litres, backfills the receipt's run/pickup/tank context in the
// cloud DB, and confirms the tank — exactly like a manual entry the driver ticked. The "Manually
// enter volume" button is the fallback for when the receipt hasn't arrived yet.
class SelectReceiptModal extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            viewOpen: false,
            viewReceipt: null,
        };
        this.openView = this.openView.bind(this);
        this.closeView = this.closeView.bind(this);
    }

    openView(receipt) {
        this.setState({ viewOpen: true, viewReceipt: receipt || null });
    }

    closeView() {
        this.setState({ viewOpen: false, viewReceipt: null });
    }

    render() {
        const { isOpen, toggle, receipts, assignedReceipts, onSelect, onUnassign, onManualEntry, loading, tankLabel } = this.props;
        const { viewOpen, viewReceipt } = this.state;
        const available = Array.isArray(receipts) ? receipts : [];
        const assigned = Array.isArray(assignedReceipts) ? assignedReceipts : [];

        return (
            <Modal isOpen={isOpen} toggle={toggle} size="lg">
                <ModalHeader toggle={toggle}>
                    Select a receipt{tankLabel ? ` for ${tankLabel}` : ''}
                </ModalHeader>
                <ModalBody>
                    {loading && <p className="text-muted">Loading receipts…</p>}

                    {!loading && <Aux>
                        <h6 className="text-muted mb-1">Available</h6>
                        {available.length === 0 && <p className="text-muted">No unassigned receipts for this truck yet.</p>}
                        {available.map((r) => (
                            <ReceiptCard key={r.id} receipt={r} showTank={false} onView={this.openView}
                                action={
                                    <Button color="success" size="lg" onClick={() => onSelect(r)}>
                                        <i className="fa fa-check" />
                                    </Button>
                                } />
                        ))}

                        {/* Receipts already tied to a tank in this pickup. Shown so a driver can undo a
                        mis-assignment, or free up both receipts when two were printed and they'd
                        rather key the combined total in by hand. */}
                        { assigned.length > 0 &&
                            <h6 className="text-muted mb-1 mt-4">Assigned to this pickup</h6>}
                        {assigned.map((r) => (
                            <ReceiptCard key={r.id} receipt={r} showTank onView={this.openView}
                                action={
                                    onUnassign
                                        ? <Button color="danger" size="lg" outline onClick={() => onUnassign(r)}>
                                            <i className="fa fa-times" />
                                          </Button>
                                        : null
                                } />
                        ))}
                    </Aux>
                    }
                    
                </ModalBody>
                <ModalFooter>
                    <Button color="primary" onClick={onManualEntry}>Manually enter volume</Button>
                    <Button color="secondary" onClick={toggle}>Cancel</Button>
                </ModalFooter>

                <Modal isOpen={viewOpen} toggle={this.closeView} size="lg">
                    <ModalHeader toggle={this.closeView}>Receipt</ModalHeader>
                    <ModalBody>
                        {viewReceipt && viewReceipt.address &&
                            <p className="mb-2"><strong>Location:</strong> {viewReceipt.address}</p>}
                        <pre style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word', marginBottom: 0 }}>{viewReceipt && viewReceipt.emailContent}</pre>
                        <div className="mt-2 text-right">
                            <Button color="secondary" onClick={this.closeView}>Close</Button>
                        </div>
                    </ModalBody>
                </Modal>
            </Modal>
        );
    }
}

SelectReceiptModal.propTypes = {
    isOpen: PropTypes.bool,
    toggle: PropTypes.func.isRequired,
    receipts: PropTypes.array,
    assignedReceipts: PropTypes.array,
    onSelect: PropTypes.func.isRequired,
    onUnassign: PropTypes.func,
    onManualEntry: PropTypes.func.isRequired,
    loading: PropTypes.bool,
    tankLabel: PropTypes.string,
};

export default SelectReceiptModal;
